import { Node } from "@antv/x6";
import { DeviceType, HALFrameType, IHALInterface, IHALDevice, ISimulatorDevice } from "./Base";


// 可用红外设备类型的列表
export const AVAILABE_INFRARED_RAY_DEVICE_TYPES = [
    DeviceType.Projector,
    DeviceType.AirConditioner,
    DeviceType.Screen
];

export const AVAILABE_INFRARED_RAY_DEVICE_TYPE_NAME_MAP = {
    [DeviceType.Projector]: "投影机",
    [DeviceType.AirConditioner]: "空调",
    [DeviceType.Screen]: "投影幕布"
};

// 红外设备记录
export interface InfraredRayDeviceRecord {
    // 红外设备类型
    deviceType: DeviceType;

    // 红外设备名称
    deviceName: string;
}

// 定义红外终端设备
export class InfraredRayDevice implements ISimulatorDevice, IHALDevice {
    protected node: Node;

    // 桥接器
    protected bridge: any;

    // 构造函数
    constructor(node: Node) {
        this.node = node;

        // 加入红外环境
        infraredRayEnviroment.add(this);
    }

    getNode(): Node<Node.Properties> {
        return this.node;
    }

    get deviceType() {
        return DeviceType.InfraredRayDevice;
    }

    // 配置桥接器，用于变更通知
    setBridge(bridge: any): void {
        this.bridge = bridge;
    }

    // 此处只返回有线连接网口
    getPorts(): IHALInterface[] {
        return [];
    }

    destory() {
        // 从红外环境中移除
        infraredRayEnviroment.remove(this);
    }

    toJSON() {
        return {
        };
    }

    fromJSON(config: any): void {
    }

    // 红外设备发送接口
    // 向环境中的所有设备（除本机）发送数据
    send(data: any, callback: Function): void {
        // 自红外环境读取设备列表
        const devices = infraredRayEnviroment.scan();

        // 遍历设备列表
        for (const device of devices) {
            // 如果设备不是自己
            if (device !== this) {
                // 向设备发送数据
                device.HAL_Recv(null, null, null, HALFrameType.InfraredRay, data, callback);
            }
        }
    }

    // 红外设备需要实现的接口，例如接收控制指令
    // 注意红外设备时fromInterface = null, toMAC = globalMAC, type = HALFrameType.InfraredRay
    HAL_Recv(fromInterface: IHALInterface | null, fromMAC: string | null, toMAC: string | null, type: HALFrameType, data: any, callback: Function): void {
        throw new Error("Method not implemented.");
    }
}

// 红外环境
// 提供扫描函数，返回红外设备列表
class InfraredRayEnviroment {
    protected devices: Array<InfraredRayDevice> = [];

    // 安装红外设备
    add(device: InfraredRayDevice) {
        this.devices.push(device);
    }

    // 卸载红外设备
    remove(device: InfraredRayDevice) {
        this.devices.splice(this.devices.indexOf(device), 1);
    }

    // 扫描函数，返回设备列表
    scan(): Array<InfraredRayDevice> {
        return this.devices;
    }
}

export const infraredRayEnviroment = new InfraredRayEnviroment();

export enum InfraredRayCommand {
    ProjectorDevicePowerOn = 0x01,
    ProjectorDevicePowerOff = 0x02,
    ScreenDevicePowerOn = 0x03,
    ScreenDevicePowerOff = 0x04,
    AirConditionerSetting = 0x05,
    AirConditionerQuery = 0x06,
}